export default __webpack_public_path__ + "static/trophy-e15cdf0737203d6dae1451a6daa6c249.webp";